export default __webpack_public_path__ + "static/media/DECA.dde6cd53.jpg";